import Plugin from './components'

function install(Vue) {
  Vue.use(Plugin)
}

export default { install }
